import {
	type IApiResponse,
	type ICountryStateByID,
	type ICountryStateByIDData,
	type IElectoralDivisionMetaDataFormHook,
	type IWardsInCountryState,
} from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type ICountryStateCreateUpdate } from '@/store/actions/core/country-state';

import { coreApiSlice } from '../apiSlice';

const stateApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createState: builder.mutation<IApiResponse, ICountryStateCreateUpdate>({
			query: (body) => ({
				url: '/State',
				method: 'POST',
				body,
			}),
		}),
		getState: builder.query<IApiResponse<ICountryStateByIDData[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/State${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		getWardsInState: builder.mutation<IApiResponse<IWardsInCountryState>, { stateIds: number[] }>({
			query: (body) => ({
				url: '/State/getWardsInState',
				method: 'POST',
				body,
			}),
		}),
		getStateById: builder.mutation<ICountryStateByID, { id: string }>({
			query: ({ id }) => ({
				url: `/State/${id}`,
				method: 'GET',
			}),
		}),
		getStateByName: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				url: '/State/name',
				method: 'POST',
				body,
			}),
		}),
		getStateByCode: builder.mutation<IApiResponse, { code: string }>({
			query: (body) => ({
				url: '/State/code',
				method: 'POST',
				body,
			}),
		}),
		updateState: builder.mutation<IApiResponse, ICountryStateCreateUpdate>({
			query: (body) => ({
				method: 'PUT',
				url: '/State/update',
				body,
			}),
		}),
		deleteState: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/State/delete/${id}`,
				method: 'DELETE',
			}),
		}),
		updateStateMetaData: builder.mutation<IApiResponse, { id: number; data: IElectoralDivisionMetaDataFormHook }>({
			query: ({ id, data }) => ({
				url: `/State/updatemetadata/${id}`,
				method: 'PUT',
				body: data,
			}),
		}),
	}),
});

export const {
	useCreateStateMutation,
	useDeleteStateMutation,
	useGetStateByCodeMutation,
	useGetStateByIdMutation,
	useGetStateByNameMutation,
	useGetStateQuery,
	useLazyGetStateQuery,
	useGetWardsInStateMutation,
	useUpdateStateMetaDataMutation,
	useUpdateStateMutation,
} = stateApiSlice;

export const selectCountryStates = stateApiSlice.endpoints.getState.select({});
